/**
 * Normalizes GET `/api/admin/industries` JSON into `{ list, total, limit, page }`.
 */

export function extractIndustriesArray(resp) {
  if (!resp || typeof resp !== "object") return [];
  return (
    (Array.isArray(resp.data) && resp.data) ||
    (Array.isArray(resp.industries) && resp.industries) ||
    (Array.isArray(resp.items) && resp.items) ||
    (Array.isArray(resp.results) && resp.results) ||
    []
  );
}

export function normalizeIndustriesListResponse(resp, fallbackLimit, fallbackPage) {
  const list = extractIndustriesArray(resp);
  const total = Number(resp.total ?? resp.meta?.total ?? resp.count ?? list.length) || 0;
  const limit = Number(resp.limit ?? resp.pageSize ?? fallbackLimit) || fallbackLimit;
  const page = Number(resp.page ?? resp.currentPage ?? fallbackPage) || fallbackPage;
  return { list, total, limit, page };
}
